<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-3 row-cols-lg-3 row-cols-xl-3">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Hiển thị trên cổng</span>
                                </label>
                                <select id="enabled_sOptions" class="form-control select2bs4" style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Đồng bộ từ IOC tỉnh</span>
                                </label>
                                <select id="IOCenabled_sOptions" class="form-control select2bs4" style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-3 row-cols-lg-3 row-cols-xl-3">
                        <div class="col mb-3">

                            <TheSelect title="Tên giải thi đấu thể thao" :options="category_GIAITHIDAU"
                                :initialValue="sValue_GIAITHIDAU" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => searchChangeGiaiThiDau(v)" />
                        </div>
                        <div class="col mb-3">

                            <TheSelect title="Tên bộ môn thể thao" :options="category_BOMON"
                                :initialValue="sValue_BOMON" :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeBoMon(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tên thành tích thể thao" :options="category_THANHTICH"
                                :initialValue="sValue_THANHTICH" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => searchChangeThanhTich(v)" />
                        </div>



                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == 1">Danh sách hiện hành</b>
                        <b v-if="sType_List == 2">Danh sách đã xóa</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == '2'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách hiện hành" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == '1'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách đã xóa" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == '2'" class="dropdown-item text-green" href="#"
                                        @click="confirmList('restore')" :title="$t('labels.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('labels.restore') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('delete')" :title="$t('labels.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.delete')
                                        }}</a>
                                    <a v-if="sType_List == '2'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('deleteReal')" :title="$t('labels.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.deleteReal')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-green" href="#"
                                        @click="confirmList('onEnabled')" title="Bật hiển thị trên Cổng"><i
                                            class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        Bật hiển thị trên cổng</a>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('offEnabled')" title="Ẩn hiển thị trên App"><i
                                            class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        Tắt hiển thị trên cổng</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-green" href="#"
                                        @click="confirmList('onEnabledIOC')" title="Bật hiển thị trên Cổng"><i
                                            class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        Bật đồng bộ từ IOC tỉnh</a>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('offEnabledIOC')" title="Ẩn hiển thị trên App"><i
                                            class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        Tắt đồng bộ từ IOC tỉnh</a>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, 'create')"
                            v-bind:title="$t('labels.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                        <!-- <button type="button" class="btn btn-tool" @click="getData" v-bind:title="$t('labels.reload')">
                    </button> -->
                        <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse"
                        v-bind:title="$t('labels.collapse')">
                        <i class="fas fa-minus"></i>
                    </button> -->
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('thethaoThanhtichTonghopId')">
                                        ID
                                        <span v-if="(orderDesc == false && sortBy == 'thethaoThanhtichTonghopId')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'thethaoThanhtichTonghopId')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenThethaoGiaithidau')">
                                        Giải thi đấu
                                        <span v-if="(orderDesc == false && sortBy == 'tenThethaoGiaithidau')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenThethaoGiaithidau')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenThethaoBomon')">
                                        Bộ môn
                                        <span v-if="(orderDesc == false && sortBy == 'tenThethaoBomon')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenThethaoBomon')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenThethaoThanhtich')">
                                        Thành tích
                                        <span v-if="(orderDesc == false && sortBy == 'tenThethaoThanhtich')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenThethaoThanhtich')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col10">Số lượng</th>
                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="(orderDesc == false && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <th class="col50">Đồng bộ từ IOC tỉnh</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.thethaoThanhtichTonghopId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList.includes(item.thethaoThanhtichTonghopId))" aria-hidden="true"
                                            class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.thethaoThanhtichTonghopId }}</td>
                                    <td>{{ item.tenThethaoGiaithidau }}</td>
                                    <td>{{ item.tenThethaoBomon }}</td>
                                    <td>{{ item.tenThethaoThanhtich }}</td>
                                    <td>{{ item.soLuong }}</td>

                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == 2" :id="'item' + item.thethaoThanhtichTonghopId"
                                                v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.thethaoThanhtichTonghopId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == 2"
                                                :id="'itemIOC' + item.thethaoThanhtichTonghopId"
                                                v-model="item.iocEnabledDisplay"
                                                v-on:click="openConfirmIOCEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'itemIOC' + item.thethaoThanhtichTonghopId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')" title="Xem chi tiết">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == 1">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, 'update')" title="Cập nhật">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, 'delete')" title="Xóa">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;

                                        <button v-if="sType_List == 2" type="button" size="sm"
                                            class="btn btn-outline-warning btn-xs" v-on:click="detail(item, 'restore')"
                                            title="Khôi phục">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-primary">{{ title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hideModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Giải thi đấu" :options="category_GIAITHIDAU"
                                        :initialValue="model.thethaoGiaithidauId" :error="errors.thethaoGiaithidauId"
                                        :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                                        :isRequire="true" @onChange="(e) => { model.thethaoGiaithidauId = e }"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Bộ môn" :options="category_BOMON"
                                        :initialValue="model.thethaoBomonId" :error="errors.thethaoBomonId"
                                        :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                                        :isRequire="true" @onChange="(e) => { model.thethaoBomonId = e }"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Thành tích" :options="category_THANHTICH"
                                        :initialValue="model.thethaoThanhtichId" :error="errors.thethaoThanhtichId"
                                        :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                                        :isRequire="true" @onChange="(e) => { model.thethaoThanhtichId = e }"
                                        :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Số lượng" placeholder="Nhập số lượng" :initialValue="model.soLuong"
                                        v-model="model.soLuong" :error="errors.soLuong" :isReadOnly="isReadOnly" :isRequire=false
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt"
                                        v-model="model.stt" :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Ghi chú" placeholder="Nhập ghi chú"
                                        :initialValue="model.ghiChu" v-model="model.ghiChu" :error="errors.ghiChu"
                                        :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Hiển thị trên cổng</label>
                                </div>
                                <div class="col-md-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="enabled-checkbox"
                                            :disabled="isReadOnly" v-model="model.enabledDisplay">
                                        <label class="custom-control-label" for="enabled-checkbox"></label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Đồng bộ từ IOC tỉnh</label>
                                </div>
                                <div class="col-md-12">
                                    <div class="custom-control custom-switch">
                                                                               <input type="checkbox" class="custom-control-input" id="ioc-enabled-checkbox"
                                            :disabled="isReadOnly" v-model="model.iocEnabledDisplay">
                                        <label class="custom-control-label" for="ioc-enabled-checkbox"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hideModal()">&nbsp;Đóng</button>

                            <button type="button" class="pull-right" :class="styleButton" v-if="code != 'detail'"
                                @click="onSubmit();">&nbsp;{{ title }}</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thethaoThanhtichTonghopId
                                            }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Giải thi đấu:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenThethaoGiaithidau
                                            }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Bộ môn:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenThethaoBomon }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Thành tích:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenThethaoThanhtich
                                            }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Số lượng:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soLuong }}&nbsp;</b>
                                    </p>


                                    <p class="text-sm">STT:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Ghi chú:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Hiển thị trên cổng:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ?
                                            "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">IOC ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.iocId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đồng bộ từ IOC tỉnh:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.iocEnabled ? "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Ngày update IOC:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.iocDateUpdated }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">{{ csList_Title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupconfirmcsListModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <p class="text-sm">Bạn có chắc chắn <b>{{ csList_Title }}</b> các dữ liệu đã chọn?</p>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hidePopupconfirmcsListModal">&nbsp;{{
                                    $t('buttons.close') }}</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" onSubmitList();">&nbsp;{{ csList_Title }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-danger" style="text-transform:uppercase;">XÁC NHẬN</h4>
                            <button type="button" class="close" aria-label="Close" @click="closeConfirmEnabledChange()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input
                                    class="custom-control-input custom-control-input-danger custom-control-input-outline"
                                    type="checkbox" v-model="checkEnable_Memo" checked="" id="checkboxMemo">
                                <label for="checkboxMemo" class="custom-control-label">Ghi nhớ không hiển thị lại xác
                                    nhận</label>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="closeConfirmEnabledChange()">&nbsp;Thoát</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" updateEnabled(2);">&nbsp;Xác nhận</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="IOCenabledConfirmModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-danger" style="text-transform:uppercase;">XÁC NHẬN</h4>
                            <button type="button" class="close" aria-label="Close"
                                @click="closeConfirmIOCEnabledChange()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <label>Bạn có chắc chắn muốn thay đổi đồng bộ từ IOC tỉnh?</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input
                                    class="custom-control-input custom-control-input-danger custom-control-input-outline"
                                    type="checkbox" v-model="checkEnable_Memo" checked="" id="checkboxMemo">
                                <label for="checkboxMemo" class="custom-control-label">Ghi nhớ không hiển thị lại xác
                                    nhận</label>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="closeConfirmIOCEnabledChange()">&nbsp;Thoát</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" updateIOCEnabled(2);">&nbsp;Xác nhận</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import { thanhTichTongHopTheThaoVHModel } from '@/models/thethao/thanhTichTongHopTheThaoVH.model'

export default {
    name: "TheThanhTichTongHopTheThaoVH",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: thanhTichTongHopTheThaoVHModel.newModel(),
            model: thanhTichTongHopTheThaoVHModel.newFEModel(),
            errors: thanhTichTongHopTheThaoVHModel.errors(),

            sValue_ID: null,
            sValue_GIAITHIDAU: null,
            sValue_BOMON: null,
            sValue_THANHTICH: null,
            sValue_SORT: null,
            sValue_ENABLED: null,
            sValue_IOCENABLED: null,

            category_GIAITHIDAU: [],
            category_BOMON: [],
            category_THANHTICH: [],
            cEnable_Value: null,
            checkEnable_Memo: false,

            csList: [],
            csList_Title: "",
            csList_Code: null,
            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        //...mapActions('adjustData', ['formatDateShow', 'fromDatetoString']),
        ...mapActions('thanhTichTongHopTheThaoVH', ['getPagingThanhTichTongHopTheThaoVH', 'getDetailThanhTichTongHopTheThaoVH', 'checkExistThanhTichTongHopTheThaoVH', 'createThanhTichTongHopTheThaoVH', 'updateThanhTichTongHopTheThaoVH', 'deleteThanhTichTongHopTheThaoVH', 'restoreThanhTichTongHopTheThaoVH', 'handleListThanhTichTongHopTheThaoVH', 'setEnabledThanhTichTongHopTheThaoVH', 'setEnabledIOCThanhTichTongHopTheThaoVH']),
        ...mapActions('giaiThiDauTheThaoVH', ['getBasicGiaiThiDauTheThao']),
        ...mapActions('boMonTheThaoVH', ['getBasicBoMonTheThaoVH']),
        ...mapActions('thanhTichThiDauTheThaoVH', ['getBasicThanhTichTheThaoVH']),



        async setup() {
            let header = 'Danh sách thành tích tổng hợp thể thao'
            this.setupHeader({ header })
        },

        async initialize() {
            // $(".select2bs4").select2({
            //     theme: "bootstrap4",
            // })
            // $('#my-colorpicker').colorpicker()
            // $('#timepicker').datetimepicker({ use24hours: true, format: 'HH:mm' })

            $('#enabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_ENABLED = returnValue
                this.handlePageChange(1)
            });

            $('#IOCenabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_IOCENABLED = returnValue
                this.handlePageChange(1)
            });
        },

        async showModal() {
            $('#insUpdModal').modal('show')

        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
            //await this.getData()
        },
        async showEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('show')
        },
        async hideEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('hide')
        },

        async showIOCEnabledConfirmModal() {
            $('#IOCenabledConfirmModal').modal('show')
        },
        async hideIOCEnabledConfirmModal() {
            $('#IOCenabledConfirmModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async selectRow(id) {
            if (this.csList.includes(id)) {
                this.csList.splice(this.csList.indexOf(id), 1)
            }
            else {
                this.csList.push(id)
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList = this.items.map((item) => {
                    return item.thethaoThanhtichTonghopId
                })
            }
            else {
                this.csList = []
            }
        },

        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }

        },

        async updateEnabled(from) {
            let model = {
                thethaoThanhtichTonghopId: this.cEnable_Value.thethaoThanhtichTonghopId,
                enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
            }
            await this.setEnabledThanhTichTongHopTheThaoVH({ model: model }).then(resp => {
                if (resp) {
                    this.hideEnabledConfirmModal()
                }
                else {
                    this.hideEnabledConfirmModal()
                }
            });
        },

        async openConfirmIOCEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showIOCEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateIOCEnabled(1)

            }
        },

        async updateIOCEnabled(from) {
            let model = {
                thethaoThanhtichTonghopId: this.cEnable_Value.thethaoThanhtichTonghopId,
                iocEnabled: from == 1 ? !this.cEnable_Value.iocEnabledDisplay : this.cEnable_Value.iocEnabledDisplay
            }
            await this.setEnabledIOCThanhTichTongHopTheThaoVH({ model: model }).then(resp => {
                if (resp) {
                    this.hideIOCEnabledConfirmModal()
                }
                else {
                    this.hideIOCEnabledConfirmModal()
                }
            });
        },

        async closeConfirmEnabledChange() {
            this.cEnable_Value.enabledDisplay =!this.cEnable_Value.enabledDisplay
            $('#item' + this.cEnable_Value.thethaoThanhtichTonghopId).prop('checked', this.cEnable_Value.enabledDisplay);
            await this.hideEnabledConfirmModal()
        },

                async closeConfirmIOCEnabledChange() {
            this.cEnable_Value.iocEnabledDisplay =!this.cEnable_Value.iocEnabledDisplay
            $('#itemIOC' + this.cEnable_Value.thethaoThanhtichTonghopId).prop('checked', this.cEnable_Value.iocEnabledDisplay);
            await this.hideIOCEnabledConfirmModal()
        },



        async searchChangeGiaiThiDau(e) {
            this.sValue_GIAITHIDAU = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeBoMon(e) {
            this.sValue_BOMON = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeThanhTich(e) {
            this.sValue_THANHTICH = e == "" ? null : e
            this.handlePageChange(1)
        },


        async getData() {
            this.isBusy = true
            this.csList = []
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                ten: this.sValue_TEN == "" ? null : this.sValue_TEN,
                thethaoGiaithidauId: this.sValue_GIAITHIDAU,
                thethaoBomonId: this.sValue_BOMON,
                thethaoThanhtichId: this.sValue_THANHTICH,
                sort: this.sValue_SORT,
                enabled: this.sValue_ENABLED,
                iocEnabled: this.sValue_IOCENABLED,
            }
            await this.getPagingThanhTichTongHopTheThaoVH({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                        this.items[i].iocEnabledDisplay = this.items[i].iocEnabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            if (this.code == 'delete' && this.sType_List == 2) this.title = this.$t('labels.deleteReal')
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = thanhTichTongHopTheThaoVHModel.errors()

            if (this.code == 'update' || this.code == 'delete' || this.code == 'restore') {
                let params = {
                    thethaoThanhtichTonghopId: item.thethaoThanhtichTonghopId
                }
                let resp = await this.getDetailThanhTichTongHopTheThaoVH({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = thanhTichTongHopTheThaoVHModel.newModel()
                        this.modelRec = resp
                        this.model = thanhTichTongHopTheThaoVHModel.parseModeltoFEModel(this.modelRec)
                        //this.triggerDetail()
                        //this.isReadOnly = (code == "create") ? false : true
                    }
                });
                this.isReadOnly = (code == "delete" || code == "restore") ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == 'detail') {
                let params = {
                    thethaoThanhtichTonghopId: item.thethaoThanhtichTonghopId
                }
                await this.getDetailThanhTichTongHopTheThaoVH({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = thanhTichTongHopTheThaoVHModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = thanhTichTongHopTheThaoVHModel.newFEModel()
                this.filesUpload = []
                //this.triggerDetail()
                this.isReadOnly = (code == "create") ? false : true
                //this.isReadOnly = this.isReadOnly = (code == "delete") ? true : false
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async validate(model) {
            let isvalid = true
            this.errors = thanhTichTongHopTheThaoVHModel.errors()

            if (!await this.validateRequired(model.thethaoGiaithidauId)) {
                this.errors.thethaoGiaithidauId = "Chọn giải đấu"
                isvalid = false
            }
            if (!await this.validateRequired(model.thethaoBomonId)) {
                this.errors.thethaoBomonId = "Chọn bộ môn"
                isvalid = false
            }
            if (!await this.validateRequired(model.thethaoThanhtichId)) {
                this.errors.thethaoThanhtichId = "Chọn thành tích"
                isvalid = false
            }
            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateNumber(model.soLuong)) {
                this.errors.soLuong = "Số lượng phải là kiểu số"
                isvalid = false
            }

            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = thanhTichTongHopTheThaoVHModel.newModel()
            if (this.code == "update" || this.code == "delete" || this.code == "restore") sendModel.thethaoThanhtichTonghopId = FEmodel.thethaoThanhtichTonghopId
            sendModel.thethaoGiaithidauId = FEmodel.thethaoGiaithidauId
            sendModel.thethaoBomonId = FEmodel.thethaoBomonId
            sendModel.soLuong = FEmodel.soLuong
            sendModel.thethaoThanhtichId = FEmodel.thethaoThanhtichId
            sendModel.ghiChu = FEmodel.ghiChu
            sendModel.stt = FEmodel.stt
            sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
            //sendModel.iocId = FEmodel.iocId
            sendModel.iocEnabled = FEmodel.iocEnabledDisplay ? FEmodel.iocEnabledDisplay : false
            return sendModel
        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            let params = null
            switch (code) {
                case "create":
                    if (await this.validate(sendModel)) {
                        res = await this.createThanhTichTongHopTheThaoVH({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "update":
                    if (await this.validate(sendModel)) {
                        res = await this.updateThanhTichTongHopTheThaoVH({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "delete":
                    // eslint-disable-next-line
                    params = {
                        thethaoThanhtichTonghopId: sendModel.thethaoThanhtichTonghopId
                    }
                    res = await this.deleteThanhTichTongHopTheThaoVH({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "deleteReal":
                    // eslint-disable-next-line
                    params = {
                        thethaoThanhtichTonghopId: sendModel.thethaoThanhtichTonghopId
                    }
                    res = await this.deleteThanhTichTongHopTheThaoVH({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "restore":
                    // eslint-disable-next-line
                    res = await this.restoreThanhTichTongHopTheThaoVH({ model: sendModel })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                default:
            }
        },

        async confirmList(code) {
            if (this.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Code = code
                if (code == 'delete') this.csList_Title = "Xóa"
                else if (code == 'deleteReal') this.csList_Title = "Xóa hoàn toàn"
                else if (code == 'restore') this.csList_Title = "Khôi phục"
                else if (code == 'offEnabled') this.csList_Title = "Tắt hiển thị"
                else if (code == 'onEnabled') this.csList_Title = "Bật hiển thị"
                else if (code == 'offEnabledIOC') this.csList_Title = "Tắt đồng bộ từ IOC tỉnh"
                else if (code == 'onEnabledIOC') this.csList_Title = "Bật đồng bộ từ IOC tỉnh"
                this.showPopupconfirmcsListModal()
            }

        },

        async onSubmitList() {
            let code = this.csList_Code
            let t = null
            let params = {
                listId: this.csList.toString()
            }
            // if(code == "offEnebaled") params.enabled = false
            // else if(code == "onEnebaled") params.enabled = true
            let res = null
            switch (code) {
                case "delete":
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 1 })
                    break
                case "deleteReal":
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 2 })
                    break
                case "restore":
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 3 })
                    break
                case "offEnabled":
                    params.enabled = false
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 4 })
                    break
                case "onEnabled":
                    params.enabled = true
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 4 })
                    break
                case "offEnabledIOC":
                    params.iocEnabled = false
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 5 })
                    break
                case "onEnabledIOC":
                    params.iocEnabled = true
                    res = await this.handleListThanhTichTongHopTheThaoVH({ model: params, type: 5 })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hidePopupconfirmcsListModal()
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistThanhTichTongHopTheThaoVH({ params: params })
            return res.data

        },

        async getCategory_GiaiThiDau() {
            let params = {

            }
            let res = await this.getBasicGiaiThiDauTheThao({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].thethaoGiaithidauId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_BoMon() {
            let params = {

            }
            let res = await this.getBasicBoMonTheThaoVH({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].thethaoBomonId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_ThanhTich() {
            let params = {

            }
            let res = await this.getBasicThanhTichTheThaoVH({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].thethaoThanhtichId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        this.category_GIAITHIDAU = await this.getCategory_GiaiThiDau()
        this.category_BOMON = await this.getCategory_BoMon()
        this.category_THANHTICH = await this.getCategory_ThanhTich()

        // $('#enabled-checkbox').on('change', e => {
        //     this.model.enabledDisplay = e.target.checked;
        // });
    }


}
</script>
<style></style>